var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useLayoutEffect, useRef, useState, } from "react";
import { Cell, Pie, PieChart } from "recharts";
import { ComplementaryData } from "./ComplementaryData";
import { WheelChartWrapper } from "./subcomponents";
import theme from "../../theme";
var WheelChart = function (_a) {
    var startAngle = _a.startAngle, endAngle = _a.endAngle, percentage = _a.percentage, renderComponent = _a.renderComponent, currentPointsValue = _a.currentPointsValue, currentPointsText = _a.currentPointsText, containerWidth = _a.width;
    var ref = useRef(null);
    var _b = useState(0), width = _b[0], setWidth = _b[1];
    useLayoutEffect(function () {
        if (ref.current)
            setWidth(ref.current.offsetWidth);
    }, []);
    var resizeListener = useCallback(function () {
        if (ref.current)
            setWidth(ref.current.offsetWidth);
    }, [ref, setWidth]);
    useEffect(function () {
        window.addEventListener("resize", resizeListener);
        return function () {
            window.removeEventListener("resize", resizeListener);
        };
    }, [resizeListener]);
    var data = [{ value: 100 - percentage }, { value: percentage }];
    var outerPadding = 5;
    var innerPadding = 25;
    var outerRadius = width / 2 - outerPadding;
    var innerRadius = width / 2 - innerPadding;
    return (_jsxs(WheelChartWrapper, __assign({ ref: ref, width: containerWidth }, { children: [_jsxs(PieChart, __assign({ width: width, height: width }, { children: [_jsxs("defs", { children: [_jsxs("linearGradient", __assign({ id: "color0", x1: "1", y1: "1", x2: "0", y2: "0" }, { children: [_jsx("stop", { offset: "0%", stopColor: theme.quickSilver, stopOpacity: 0.1 }), _jsx("stop", { offset: "100%", stopColor: theme.lightestGrey, stopOpacity: 1 })] })), _jsxs("linearGradient", __assign({ id: "color1", x1: "1", y1: "1", x2: "0", y2: "0" }, { children: [_jsx("stop", { offset: "10%", stopColor: theme.rackley, stopOpacity: 0.2 }), _jsx("stop", { offset: "75%", stopColor: theme.darkSlateGray, stopOpacity: 1 })] }))] }), _jsx(Pie, __assign({ data: data, cx: width / 2, cy: width / 2, innerRadius: innerRadius, outerRadius: outerRadius, endAngle: endAngle, startAngle: startAngle, dataKey: "value", blendStroke: true, isAnimationActive: false }, { children: data.map(function (entry, index) { return (_jsx(Cell, { fill: "url(#color".concat(index, ")") }, "cell-".concat(entry))); }) }))] })), renderComponent ? (renderComponent()) : (_jsx(ComplementaryData, { currentWidth: width, currentPointsValue: currentPointsValue, currentPointsText: currentPointsText }))] })));
};
export default WheelChart;
